export const sortedTagsList = [
  "your rent include",
  "dual occupancy",
  "wi-fi",
  "wifi",
  "gyms",
  "gym",
  "fully furnished",
  "parking",
  "laundry",
  "secured premise",
  "common social area",
  "recycling",
  "swimming pool",
  "contents insurance",
  "reception staff",
  "kitchen",
  "double occupancy",
  "air conditioning",
  "storage",
  "guarantor requirement",
  "university distance",
  "fridge",
  "parcel collection",
  "breakfast bar",
  "coffee machine",
  "pet friendly",
  "no pets",
  "games room",
  "cinema room",
  "library",
  "lounge",
  "garbage disposal",
  "balcony/ terrace/ patio",
  "balcony",
  "terrace",
  "patio",
  "shuttle/ cab service",
  "shuttle",
  "cab service",
] as const;

const getSortedTags = (tagList: any) =>
  tagList
    ?.filter((tag: string) => tag !== "not_available") // Remove not available tag used by CRM
    ?.map((tag: string) => tag?.replace(/_/g, " ")) // Remove underscores
    ?.slice() // To prevent mutation
    // Sort according to provided sorted list array
    ?.sort((a: any, b: any) => {
      // Move items not present to end
      if (sortedTagsList.indexOf(b?.toLowerCase()) === -1) {
        return -1;
      }
      if (sortedTagsList.indexOf(a?.toLowerCase()) === -1) {
        return 1;
      }
      // Sort according to list provided
      return sortedTagsList?.indexOf(a?.toLowerCase()) - sortedTagsList?.indexOf(b?.toLowerCase());
    }) || [];

export default getSortedTags;
